import { Post, Get, Patch, Put, Delete, Download, ax } from './http';
import { type } from './interface';
import qs from 'qs';
export namespace ServiceChargeBill {
    /**
    *  服务费月账单列表
    */
    export var GetBillList = (query: any): Promise<any> => {
        return Get(`/msls/ServiceChargeBill/GetBillList?${qs.stringify(query)}`, {});
    };
    /**
     * 服务费月账单导出
     */
    export var BillListExport = (query: any): Promise<any> => {
        return Download(`/msls/ServiceChargeBill/BillListExport?${qs.stringify(query)}`, {});
    };
    /**
    * 服务费账单明细列表
    */
    export var GetBillDetailList = (id: any, query: any): Promise<any> => {
        return Get(`/msls/ServiceChargeBill/GetDetailList/${id}?${qs.stringify(query)}`, {});
    };
    /**
     * 服务费账单明细列表导出
     */
    export var BillDetailListExport = (id: any, query: any): Promise<any> => {
        return Download(`/msls/ServiceChargeBill/DetailListExport/${id}?${qs.stringify(query)}`, {});
    };
}